// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__OLjIB","error":"Textarea_error__3qXx0","readonly":"Textarea_readonly__2fSF2","disabled":"Textarea_disabled__2TYHa"};